import Icon from "../../../components/AppIcon";

const VisionManifesto = ({ className = "" }) => {
  const manifestoPoints = [
    {
      id: 1,
      icon: "Bolt",
      title: "Bold by Design",
      description:
        "We refuse to play small. Every project is an opportunity to create something that commands attention and drives real business results.",
    },
    {
      id: 2,
      icon: "ChartBar",
      title: "Strategy First",
      description:
        "Visibility without strategy is noise. We engineer every creative decision for measurable impact and sustainable growth.",
    },
    {
      id: 3,
      icon: "Sparkles",
      title: "Excellence Standard",
      description:
        "We exist at the intersection of artistic excellence and business strategy—where Fortune 500 ambitions meet authentic African creative energy.",
    },
    {
      id: 4,
      icon: "Rocket",
      title: "Results Obsessed",
      description:
        "We don't just make it beautiful. We make it profitable. Every campaign is engineered for conversion and ROI.",
    },
    {
      id: 5,
      icon: "Globe",
      title: "Global Perspective",
      description:
        "Rooted in African excellence, designed for global impact. We bring authentic cultural perspective to international standards.",
    },
    {
      id: 6,
      icon: "ShieldCheck",
      title: "Accountability Always",
      description:
        "Creativity with consequence. Artistry with accountability. We guarantee transformation, not just transactions.",
    },
  ];

  return (
    <section className={`py-4 sm:py-12 bg-background ${className}`}>
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-4 space-y-4">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-headline font-black text-foreground">
              Our <span className="text-red-600">Manifesto</span>
            </h2>
            <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto">
              These aren&apos;t just values—they&apos;re the non-negotiable
              principles that drive every decision, every campaign, and every
              client relationship.
            </p>
          </div>

          {/* Manifesto Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-8 mb-4 sm:mb-12">
            {manifestoPoints.map((point) => (
              <div
                key={point.id}
                className="group p-4  bg-card rounded-2xl border shadow-subtle hover:border-red-600 transition-all duration-300 hover:shadow-dramatic"
              >
                <div className="flex flex-col items-start space-y-4">
                  <div className="hidden sm:block p-4 border shadow-subtle hover:border-red-600 rounded-xl  group-hover:scale-125 transition-all duration-300">
                    <Icon
                      name={point.icon}
                      size={32}
                      variant="solid"
                      className="text-red-600 group-hover:text-red-500 transition-colors duration-300"
                    />
                  </div>
                  <h3 className="text-xl font-headline font-bold text-foreground group-hover:text-red-600 transition-colors duration-300">
                    {point.title}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {point.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Bottom CTA */}
          <div className=" text-center">
            <p className="text-lg md:text-3xl font-headline font-bold text-foreground mb-2 sm:mb-8 ">
              Ready to work with an agency that{" "}
              <span className="text-red-600">refuses to compromise</span>?
            </p>
            <a
              href="/booking-concierge-premium-consultation"
              className="inline-flex items-center space-x-2 bg-red-700 hover:bg-accent/90 text-white px-4 py-2 rounded-lg font-semibold text-sm sm:text-lg cinematic-transition hover:shadow-elevation uppercase"
            >
              Let&apos;s Create Something Extraordinary
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionManifesto;
